<nav class="l-side-nav">
    <ul class="side-nav">
        <li class="is-active"><span>Home</span></li>
        <li id="why-us"><span>Why Us?</span></li>
        <li class=""><span>Our Pitch</span></li>
        <li class=""><span>Clients</span></li>
        <li class=""><span>Pivoting Map</span></li>
        <li class=""><span>Contact</span></li>

    </ul>
</nav>